import { Hint } from 'components';
import { ListTypography, Typography } from 'libs/ui';

import { HintContainer, HintTitleStyled } from './FieldLabelWithHint.styles';

type Props = {
  hintTitle: string;
  hintTexts: string[];
  label: string;
};

export const FieldLabelWithHint = ({ hintTitle, hintTexts, label }: Props) => (
  <Typography>
    {label}
    <HintContainer>
      <Hint
        title={
          <HintTitleStyled spacing={4}>
            <Typography variant="bodyBold">{hintTitle}</Typography>
            <ListTypography
              listType="ul"
              spacing={4}
              texts={hintTexts}
              variant="caption"
            />
          </HintTitleStyled>
        }
      />
    </HintContainer>
  </Typography>
);
